import { Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";

interface KpiCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  isLoading: boolean;
}

export function KpiCard({ title, value, icon, isLoading }: KpiCardProps) {
  return (
    <Card className="bg-white/[0.03] border-white/[0.06]">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {icon}
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        ) : (
          <div className="text-2xl font-bold font-mono">{value}</div>
        )}
      </CardContent>
    </Card>
  );
}
